export const perPageLimit = 50;
export const pageNeighbours = 2;
export const ukCode = '44';

export const defaultCountryCode = 'GB';

export enum CountryCodes {
  'AU' = 'AU',
  'GB' = 'GB',
}

export type TemperatureUnitTypes = 1 | 2;

export const temperatureSymbols: Record<TemperatureUnitTypes, string> = {
  1: 'C',
  2: 'F',
};
